import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceCommissionById } from '@/api/financial-center'
import { menuBtn } from '@/utils/menu_level2_button'
@Component({})
export default class BackMoneyParnterInfo extends Vue {
    logShow = true
    backMoneyId = NaN
    backMoneyInfo: any = ''
    infoStatus: any = ''
    status = ''
    fileList = []
    fileList1 = []
    proofArr = {}
    turnParagraphArr = []
    moneyCertificatesArr = []
    isUpdatedData = '0'
    isShow = ''
    activities = []
    financeCommissionAccount ={}
    Accounttype = ''
    loading = false

    get orderAllPrice() {
        let num = 0
        if(this.backMoneyInfo.financeCommissionDetailList){
            this.backMoneyInfo.financeCommissionDetailList.map(item => num += Number(item.priceSum))
        }
        return num
    }
    menuBtn = menuBtn


    get turnParagraphUrl() {//转款
        return this.turnParagraphArr.map(item => item.url)
    }
    get moneyCertificatesUrl() {//打款
        return this.moneyCertificatesArr.map(item => item.url)
    }

    created() {
        this.backMoneyId = Number(this.$route.query.id)
        this.isUpdatedData = this.$route.query.isUpdatedData as string || '0'
        this.infoStatus = this.$route.query.status
        this.getFinanceCommissionById()
        if(this.$route.query.status) this.status = this.$route.query.status as string
    }

    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }

    formatDate = formatDate
    async getFinanceCommissionById() {
        this.loading = true
        await getFinanceCommissionById({ id: this.backMoneyId, isUpdatedData: this.isUpdatedData }).then((data: any)=>{
        this.backMoneyInfo = data.financeCommission
        this.isShow = data.financeCommission.isShow
        //    审批流程
        this.activities = data.financeCommission.messageReviewList
        this.backMoneyInfo.financeCommissionProofList.map(item => {
            if(item.types == '1'){
                this.turnParagraphArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
            if(item.types == '0'){
                this.moneyCertificatesArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
        })
        this.financeCommissionAccount = this.backMoneyInfo.financeCommissionAccount
        this.Accounttype = this.financeCommissionAccount ? (this.financeCommissionAccount as any).type : ''
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    editBackMoney() {
        if(this.status === '审批中') {
            this.$message.error('审批中，不可编辑')
            return
        }

        this.$router.push({
            path: 'commissionEdit',
            query: {
                id: String(this.backMoneyId),
                isShow: this.isShow,
                status: this.status,
                isUpdatedData: this.isUpdatedData
            }
        })
    }
    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList.push({ name: data.name, url: data.ossUrl })
    }
    uploadSuccess1(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList1.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    uploadError1() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }
    handleUploadRemove1(file) {
        this.fileList1 = this.fileList1.filter(item => item.uid !== file.uid)
    }

    previewContractUrl() {
        window.open(this.backMoneyInfo.financeContractUrl, 'blank')
    }
}
